import {
    get,
    post
} from '@/utils/request'


const SERVICE_URL = '/order-service/v1'

// 零件级采购预测
export function getForecastList(params) {
    return post(SERVICE_URL + '/SapPurchaseForecast/getSapPurchaseForecast', params)
}
export function getForecastById(params, pathParam) {
    return get(SERVICE_URL + '/SapPurchaseForecast/getSapPurchaseForecastID', params, pathParam)
}
export function createForecast(params) {
    return post(SERVICE_URL + '/SapPurchaseForecast/addSapPurchaseForecast', params)
}
export function editForecast(params) {
    return post(SERVICE_URL + '/SapPurchaseForecast/editSapPurchaseForecast', params)
}
export function removeForecast(params,pathParam) {
    return get(SERVICE_URL + '/SapPurchaseForecast/removeSapPurchaseForecast', params,pathParam)
}

// 库存共享
export function getSapStoreShare(params) {
    return post(SERVICE_URL + '/SapStoreShare/getSapStoreShare', params)
}
export function getStoreShareById(params, pathParam) {
    return get(SERVICE_URL + '/SapStoreShare/getSapStoreShareById', params, pathParam)
}
export function createStoreShare(params) {
    return post(SERVICE_URL + '/SapStoreShare/addSapStoreShare', params)
}
export function editStoreShare(params) {
    return post(SERVICE_URL + '/SapStoreShare/editSapStoreShare', params)
}
export function removeStoreShare(params,pathParam) {
    return get(SERVICE_URL + '/SapStoreShare/removeSapStoreShare', params,pathParam)
}

//整车预测
export function getCarForecastList(params) {
    return post(SERVICE_URL + '/sapCarForecast/getSapCarForecastList', params)
}
export function getCarForecastById(params, pathParam) {
    return get(SERVICE_URL + '/sapCarForecast/getBySapCarForecastId', params, pathParam)
}
export function createCarForecast(params) {
    return post(SERVICE_URL + '/sapCarForecast/addSapCarForecast', params)
}
export function editCarForecast(params) {
    return post(SERVICE_URL + '/sapCarForecast/editSapCarForecast', params)
}
export function removeCarForecast(params,pathParam) {
    return get(SERVICE_URL + '/sapCarForecast/removeSapCarForecast', params,pathParam)
}

//日需求计划
export function getDayPlanList(params) {
    return post(SERVICE_URL + '/sapDayPlan/getSapDayPlanList', params)
}
export function getBySapDayPlanId(params, pathParam) {
    return get(SERVICE_URL + '/sapDayPlan/getBySapDayPlanId', params, pathParam)
}
export function createDayPlan(params) {
    return post(SERVICE_URL + '/sapDayPlan/addSapDayPlan', params)
}
export function editDayPlan(params) {
    return post(SERVICE_URL + '/sapDayPlan/editSapDayPlan', params)
}
export function removeDayPlan(params,pathParam) {
    return get(SERVICE_URL + '/sapDayPlan/removeSapDayPlan', params,pathParam)
}
/** 日需求计划批量导出 */
export function exportDayPlanData(params) {
    return post(SERVICE_URL + '/upload-file/export-day-plan', params)
}


//采购订单交货历史
export function getDeliveryHistoryList(params) {
    return post(SERVICE_URL + '/sapHistory/getSapDeliveryHistoryList', params)
}
export function getByDeliveryHistoryId(params, pathParam) {
    return get(SERVICE_URL + '/sapHistory/getBySapDeliveryHistoryId', params, pathParam)
}
export function createDeliveryHistory(params) {
    return post(SERVICE_URL + '/sapHistory/addSapDeliveryHistory', params)
}
export function editDeliveryHistory(params) {
    return post(SERVICE_URL + '/sapHistory/editSapDeliveryHistory', params)
}
export function removeDeliveryHistory(params,pathParam) {
    return get(SERVICE_URL + '/sapHistory/removeSapDeliveryHistory', params,pathParam)
}

export function getDeliveryHistoryDetailList(params) {
    return post(SERVICE_URL + '/sapHistory/getSapDeliveryHistoryDetailList', params)
}
export function getByDeliveryHistoryDetailId(params, pathParam) {
    return get(SERVICE_URL + '/sapHistory/getBySapDeliveryHistoryDetailId', params, pathParam)
}
export function createDeliveryHistoryDetail(params) {
    return post(SERVICE_URL + '/sapHistory/addSapDeliveryHistoryDetail', params)
}
export function editDeliveryHistoryDetail(params) {
    return post(SERVICE_URL + '/sapHistory/editSapDeliveryHistoryDetail', params)
}
export function removeDeliveryHistoryDetail(params,pathParam) {
    return get(SERVICE_URL + '/sapHistory/removeSapDeliveryHistoryDetail', params,pathParam)
}

// 库存报表
export function getSapStoreTbl(params) {
    return post(SERVICE_URL + '/SapStoreTbl/getSapStoreTbl', params)
}